<div class='app-version row'>
    {{ getVersion() }}
</div>
<div class='app-version row'>
    {{ getApiData() }}
</div>
